<template>
	<component
		:is="props.asChild ? 'slot' : 'button'"
		:class="cn(buttonVariants({ variant, size }), props.class)"
		v-bind="$attrs"
	>
		<slot />
	</component>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';
import { buttonVariants, type ButtonVariants } from './buttonVariants';

const props = withDefaults(
	defineProps<{
		variant?: ButtonVariants['variant'];
		size?: ButtonVariants['size'];
		asChild?: boolean;
		class?: string;
	}>(),
	{
		variant: 'default',
		size: 'default',
		asChild: false,
	},
);
</script>
